import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const Navbar = ({
  onPreviousClick,
  onNextClick,
  showPreviousButton,
  showNextButton,
  previousMonth,
  nextMonth,
  onChange,
  className,
}) => {
  const handlePreviousClick = () => {
    if (showPreviousButton) {
      onPreviousClick();
      onChange(previousMonth);
    }
  };
  const handleNextClick = () => {
    if (showNextButton) {
      onNextClick();
      onChange(nextMonth);
    }
  };

  return (
    <div className={className}>
      <button
        type="button"
        onClick={handlePreviousClick}
        className={cx('DayPicker-NavButton DayPicker-NavButton--prev', { disabled: !showPreviousButton })}
      >
        <i className="hicon-angle-right-alt" />
      </button>

      <button
        type="button"
        onClick={handleNextClick}
        className={cx('DayPicker-NavButton DayPicker-NavButton--next', { disabled: !showNextButton })}
      >
        <i className="hicon-angle-right-alt" />
      </button>
    </div>
  );
};

Navbar.propTypes = {
  className: PropTypes.string,
  onPreviousClick: PropTypes.func,
  onNextClick: PropTypes.func,
  showNextButton: PropTypes.bool,
  showPreviousButton: PropTypes.bool,
  previousMonth: PropTypes.instanceOf(Date),
  nextMonth: PropTypes.instanceOf(Date),
  onChange: PropTypes.func,
};

export default Navbar;
